import { useEffect, useRef, useState } from 'react'
import { FormFieldProps, FormJsonType } from './type'
import JSONEditor from 'jsoneditor'
import 'jsoneditor/dist/jsoneditor.min.css'
import { useFormContext } from 'react-hook-form'

export const FormJsonField = ({
  data,
  field,
}: FormFieldProps<FormJsonType>) => {
  const container = useRef<HTMLDivElement>(null)
  const editor = useRef<JSONEditor>()
  const context = useFormContext()

  const [initalized, setInitalized] = useState(false)

  useEffect(() => {
    if (editor.current) {
      return
    }

    const _editor = new JSONEditor(container.current!, {
      mode: 'code',
      allowSchemaSuggestions: true,
      onChangeText(json) {
        try {
          field.onChange(JSON.parse(json))
        } catch (e) {
          console.warn(e)
        }
      },
    })

    if (data.default) {
      _editor.set(data.default)
    }

    editor.current = _editor
  }, [data.default])

  useEffect(() => {
    if (!editor.current) {
      return
    }

    const initialValue = context.getValues(data.key)

    if (editor.current) {
      const selection = editor.current.getTextSelection()
      editor.current.set(initialValue)
      editor.current.setTextSelection(selection.start, selection.end)

      if (!initalized) {
        setTimeout(() => {
          setInitalized(true)
        }, 100)
      }
    }
  }, [initalized, context, data.key])

  return (
    <div className="flex gap-4">
      <style>
        {`
          .json-editor .ace_content * {
            font-family: consolas, menlo, monaco, "Ubuntu Mono", source-code-pro, monospace !important;
          }
        `}
      </style>
      <div
        ref={container}
        className="json-editor h-[600px] flex-1"
        style={{
          display: initalized ? 'block' : 'none',
        }}
      />
    </div>
  )
}
